module.exports = __webpack_public_path__ + "img/037.4221af92.jpg";